<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>链接管理</el-breadcrumb-item>
      <el-breadcrumb-item>链接列表</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card>
      <el-row :gutter="10">
          <el-col :span="3">
          <el-date-picker
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            v-model="start_date"
            type="date"
            placeholder="开始日期">
          </el-date-picker>
        </el-col>

        <el-col :span="4">
          <el-date-picker
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            v-model="end_date"
            type="date"
            placeholder="结束日期">
          </el-date-picker>
        </el-col>

        <el-col :span="2">
           <el-button type="success" @click="getLinkList">按日期查询</el-button>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" @click="newLink">新链接管理</el-button>
        </el-col>
      </el-row>
      <el-table :data="linklist" stripe style="width:100%!important">
        <el-table-column label="#" type="index" width="60"></el-table-column>
        <el-table-column label="域名" prop="hostname" width="190"></el-table-column>
        <el-table-column label="短链接" prop="shurt_link" width="290"></el-table-column>
        <el-table-column label="长链接" prop="old_link" width="750"></el-table-column>
        <el-table-column label="创建日期" prop="creatTimer" width="200"></el-table-column>
        <el-table-column label="操作" width="130">
          <template slot-scope="scope">
            <el-button @click="CopyLink(scope.row.shurt_link)" type="success" size="medium">拷贝短链</el-button>           
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.page_number"
        :page-sizes="[5, 10, 20, 30]"
        :page-size="queryInfo.page_size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="allCount">
      </el-pagination>
    </el-card>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  data() {
    return {
      queryInfo:{
        page_number:1,
        page_size:5
      },
      start_date:'',
      end_date:'',
      linklist:[],
      allCount:0
    }
  },
  created(){
    this.getLinkList()
  },
  methods: {
    async getLinkList(){
      var page_number = this.queryInfo.page_number;
      var page_size = this.queryInfo.page_size;

      axios({
        method: "post",
        url: "http://144.202.120.54/api/ShortLinks/linkListOld",
        params: {
          ids:window.sessionStorage.getItem('ids'),
          page_number: page_number,
          page_size: page_size,
          start_date: this.start_date,
          end_date: this.end_date,
          token:window.sessionStorage.getItem('token')
        },
      }).then((res) => {
          if(res.data.code == 0){
            this.$message.error('此域名下无老链接数据!');
            return false; 
          } 
          if(res.data.code ==200){
            this.linklist = res.data.data.link_Arr
            this.allCount = res.data.data.allCount        
          }
      })
    },
    CopyLink(short_link){

      var input = document.createElement('input')
      input.value = short_link;
      document.body.appendChild(input);
      input.select();
      if(document.execCommand('copy')){
        this.$message.success('拷贝成功!');
        document.body.removeChild(input);
      }
    },
    newLink(){
         this.$router.push('/link');
    },
    //监听pagesize改变事件
    handleSizeChange(newSize){
      console.log(newSize)
      this.queryInfo.page_size = newSize
      this.getLinkList()
    },
    handleCurrentChange(newPage){
      console.log(newPage)
      this.queryInfo.page_number = newPage
      this.getLinkList()
    }
  }
}
</script>
<style lang="less" scoped>
  .el-pagination{margin-top: 15px;}
</style>